import type { i18n } from 'i18next';
import { storeToRefs } from 'pinia';

import { pinia } from '@/plugins';
import { getInitialLanguage } from '@/plugins/i18n/init.i18n.ts';
import { useConfigurationStore } from '@/stores/admin/configuration.pinia';
import { useOrganizationStore } from '@/stores/admin/organzation.pinia.ts';
import { useLocaleStore } from '@/stores/shared/locale.pinia.ts';
import { useVuetifyStore } from '@/stores/shared/vuetify.pinia.ts';

export const configureStores = async (i18nextInstance: i18n) => {
  const localeStore = useLocaleStore(pinia);
  const organizationsStore = useOrganizationStore(pinia);
  const vuetifyStore = useVuetifyStore(pinia);

  await organizationsStore.getOrganizationUsingUrl();
  await Promise.all([
    localeStore.changeLocale(getInitialLanguage(), i18nextInstance, false),
    organizationsStore.callOrganization(),
  ]);
  useConfigurationStore().setOrganizationTerms();

  const { organization } = storeToRefs(organizationsStore);
  if (organization?.value) {
    const { colors, fontFamilies, icon } = organization.value;
    vuetifyStore.changeThemeMainColors(colors?.[0]?.color, colors?.[1]?.color);
    vuetifyStore.changeFontFamily(fontFamilies);
    vuetifyStore.changeFavoriteIcon(icon?.url || '');
  }
};
